import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";

// Material
import Box from "@material-ui/core/Box";

// Config
import colors from "src/config/colors";

// Images
import lightBulb from "../../../assets/icons/light_bulb.svg";

const useStyles = makeStyles(theme => ({
  boxWrapper: {
    display: "flex",
    flexDirection: "row",
    marginBottom: theme.spacing(1),
    padding: theme.spacing(3),
    borderRadius: 10,
    backgroundColor: colors.lilyWhite,
    gap: theme.spacing(2)
  },
  box: {
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(1)
  }
}));

const StatementInputDescription = ({ content }) => {
  const classes = useStyles();

  return (
    <Box className={classes.boxWrapper}>
      <img src={lightBulb} alt="" height={16} />
      <Box className={classes.box}>{content}</Box>
    </Box>
  );
};

StatementInputDescription.propTypes = {
  content: PropTypes.string
};

StatementInputDescription.defaultProps = {
  content: null
};

export default StatementInputDescription;
